/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import EventCardLine from '/client/src/components/eventCard/lineCard';
import EventCardLineSimple from '/client/src/components/eventCard/lineCardSimple';
import EventCardLineCharts from '/client/src/components/eventCard/lineCardCharts';
import Loader from '/client/src/components/Loader';
import moment from 'moment';

type GridType2or3PropsType = {
  type: number,
  eventList: [],
  idsEventList: string,
  collaboratorsList: [],
  transactionsList: [],
  setEventList: () => void
};

const GridType2or3 = ({
  type,
  eventList,
  collaboratorsList,
  idsEventList,
  transactionsList,
  setEventList
}: GridType2or3PropsType): React.Element<'div'> => {
  const [progressPending, setProgressPending] = React.useState(true);
  const [stats, setStats] = React.useState([]);

  const handleLoaded = React.useCallback(async (error: Error, response: any) => {
      if (!error) {
        try {
          setStats(_.get(response, 'data.result', {}));
          setProgressPending(false);
        } catch (e) {
          console.log(e);
          console.error('cant get stats data');
          setProgressPending(false);
        }
      }
    },
    []
  );

  const LoaderWrap = (children: React.Element<typeof React.Fragment>): React.Node => {
    return (
      <Loader
        url={`/api/v1/1/statistics/events/transaction/week?ids=${idsEventList}&timezone_offset=${moment().utcOffset()}`}
        onLoaded={handleLoaded}
      >
        {children}
      </Loader>
    );
  };

  const content = (
    <>
      <EventCardLine type='new-event' />
      {!progressPending &&
      _.map(eventList, (ev: {}, evi: number): React.Element => {
        let _collaboratorsList = [];

        _.forEach(collaboratorsList, (ci: {}): [] => {
          if (_.toString(ci.event_id) === _.toString(ev.id)) {
            _collaboratorsList = ci.collaborators;
          }
        });

        const transactions = {
          ..._.find(transactionsList, (ti: {}): {} => (_.toString(ti.event_id) === _.toString(ev.id))),
          stats: stats[ev.id]
        };

        if (+type === 2) {
          return (
            <EventCardLineSimple
              {...ev}
              key={`EventCardLine-${evi}`}
              collaboratorsList={_.compact(_collaboratorsList)}
              transactions={transactions}
              setEventList={setEventList}
              eventList={eventList}
            />
          );
        }

        if (+type === 3) {
          return (
            <EventCardLineCharts
              {...ev}
              key={`EventCardLine-${evi}`}
              collaboratorsList={_.compact(_collaboratorsList)}
              transactions={transactions}
              setEventList={setEventList}
              eventList={eventList}
            />
          );
        }
      })
      }
    </>
  );

  if (_.size(idsEventList)) {
    return LoaderWrap(content);
  }

  return (
    <>{content}</>
  );
};

export default GridType2or3;
